import type { ReactElement } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { MAX_CHIPS_GROUP_AMOUNT } from "app/pages/sales-intelligence/common-components/filters-panel/constants";
import type {
    IAppsAndroidCategoryFilter,
    IAppsIosCategoryFilter,
} from "app/pages/sales-intelligence/domain/apps/types/filter-values";
import { appsCategoryTypesMap } from "app/pages/sales-intelligence/domain/apps/types/filter-values";
import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

const AppIosCategoryFilterResult = ({
    value,
    onFilterUpdate,
    isExpanded,
}: IFilterViewBaseModelProps<IAppsIosCategoryFilter>): ReactElement | null => {
    const categoryValues = (value as IAppsAndroidCategoryFilter)?.values || [];
    const chipItems = categoryValues.map((item: string) => ({ id: item, text: item }));

    const handleRemoveValue = (valueItem: string) => {
        const filterData: IAppsIosCategoryFilter = {
            values: categoryValues.filter((item: string) => item !== valueItem),
            type: value?.type || appsCategoryTypesMap.all,
        };
        onFilterUpdate(filterData.values.length > 0 ? filterData : undefined);
    };

    if (categoryValues.length === 0) {
        return null;
    }

    return (
        <Flex flexWrap="wrap">
            <LimitedChipItems
                items={chipItems}
                onDelete={handleRemoveValue}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                isTabExpanded={isExpanded}
            />
        </Flex>
    );
};

export default AppIosCategoryFilterResult;
